import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from "reselect";
import { getLoggedInUser } from "../../helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";

const ProfileDropdown = ({ toggleKotOpen, toggleTableModal }) => {
  const auth = getLoggedInUser();
  const profiledropdownData = createSelector(
    (state) => state.Profile.user,
    (user) => user
  );
  console.log(auth);
  // Inside your component
  const user = useSelector(profiledropdownData);

  const [userName, setUserName] = useState("Admin");
  const userRole = auth?.user?.roles[0]?.toLowerCase();

  useEffect(() => {
    if (sessionStorage.getItem("authUser")) {
      const obj = JSON.parse(sessionStorage.getItem("authUser"));
      setUserName(
        process.env.REACT_APP_DEFAULTAUTH === "fake"
          ? obj.username === undefined
            ? user.first_name
              ? user.first_name
              : obj.data.first_name
            : "Admin" || "Admin"
          : process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? obj.email && obj.email
          : "Admin"
      );
    }
  }, [userName, user]);

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear(); // Clear all local storage
    localStorage.removeItem("cartOrders");
    navigate("/"); // Navigate to home page
  };
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const toggleProfileModal = () => setIsProfileModalOpen((p) => !p);
  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 "
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <img
              className="rounded-circle header-profile-user"
              src={avatar1}
              alt="Header Avatar"
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {auth?.user?.name}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text"></span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <h6 className="dropdown-header">Welcome {userName}!</h6> */}
          <h6 className="dropdown-header">Welcome {auth?.userName}!</h6>
          {/* <DropdownItem href={process.env.PUBLIC_URL + "/CustomerAUS"}>
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Profile</span>
          </DropdownItem> */}
          {/* <DropdownItem href={process.env.PUBLIC_URL + "/apps-chat"}><i
                        className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Messages</span></DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "#"}><i
                        className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Taskboard</span></DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "/pages-faqs"}><i
                        className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Help</span></DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem href={process.env.PUBLIC_URL + "/pages-profile"}><i
                        className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Balance : <b>$5971.67</b></span></DropdownItem> */}
          {/* <DropdownItem href={process.env.PUBLIC_URL + "/"}>
            <span className="badge bg-success-subtle text-success mt-1 float-end">
              New
            </span>
            <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Settings</span>
          </DropdownItem> */}
          {/* <DropdownItem
            href={process.env.PUBLIC_URL + "/auth-lockscreen-basic"}
          >
            <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Lock screen</span>
          </DropdownItem> */}
          {/* <DropdownItem onClick={toggleTableModal}>
            <i className="ri-restaurant-line text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Table</span>
          </DropdownItem> */}

          <DropdownItem
            onClick={toggleKotOpen}
            className="d-lg-none d-md-none d-block"
          >
            <i class="ri-file-list-3-line text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">KOT</span>
          </DropdownItem>

          <DropdownItem href={process.env.PUBLIC_URL + "/profile"}>
            <i className="bx bx-user text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">My Profile</span>
          </DropdownItem>

          <DropdownItem href={process.env.PUBLIC_URL + "/change-password"}>
            <i className="bx bx-lock text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Change password</span>
          </DropdownItem>
          <DropdownItem href={process.env.PUBLIC_URL + "/logout"}>
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle" data-key="t-logout">
              Logout
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Modal isOpen={isProfileModalOpen} toggle={toggleProfileModal} size="md">
        <ModalHeader toggle={toggleProfileModal}>My Profile</ModalHeader>
        <ModalBody>
          <div className="d-flex align-items-center gap-3">
            <img
              src={avatar1}
              alt="avatar"
              className="rounded-circle"
              style={{ width: 80, height: 80, objectFit: "cover" }}
            />
            <div>
              <h5 className="mb-1">
                {auth?.user?.name || auth?.userName || "Admin"}
              </h5>
              <div className="text-muted">
                Email: {auth?.email || auth?.user?.email || "-"}
              </div>
              <div className="text-muted">
                Username: {auth?.userName || auth?.user?.userName || "-"}
              </div>
              <div className="text-muted">
                ID: #{auth?.id || auth?.user?.id || "-"}
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              toggleProfileModal();
              navigate(process.env.PUBLIC_URL + "/profile");
            }}
          >
            Open Full Profile
          </Button>
          <Button color="secondary" onClick={toggleProfileModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default ProfileDropdown;
